import { motion } from "framer-motion";
import { IMAGES, PHOTO_STRIP } from "@/constants/site";

export const PhotoStrip = () => (
  <section className="mt-8 bg-gray-50 border-y border-gray-100 py-8" data-testid="photo-strip">
    <div className="max-w-6xl mx-auto px-3 md:px-6">
      <motion.h3
        initial={{ opacity: 0, y: 14 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.15 }}
        className="text-base md:text-lg font-extrabold tracking-tight text-fr-ink"
        data-testid="photo-strip-title"
      >
        Foto reali della flotta
      </motion.h3>
      <div className="mt-4 grid grid-cols-3 sm:grid-cols-5 md:grid-cols-9 gap-2" data-testid="photo-strip-grid">
        {PHOTO_STRIP.map((p, i) => (
          <motion.figure
            key={p.name}
            initial={{ opacity: 0, y: 12 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ delay: i * 0.05 }}
            className="group"
          >
            <div className="aspect-[4/3] rounded-lg overflow-hidden bg-white border border-gray-200">
              <img
                src={IMAGES.cars[p.img]}
                alt={`Foto ${p.name} flotta FabriRent`}
                loading="lazy"
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                data-testid={`photo-strip-thumb-${p.img}`}
              />
            </div>
            <figcaption className="mt-1 text-center text-[9px] font-semibold text-gray-500">{p.name}</figcaption>
          </motion.figure>
        ))}
      </div>
      <p className="mt-4 text-[10px] text-gray-400" data-testid="photo-strip-disclaimer">
        Le foto mostrano i modelli della flotta o modelli identici "o similare". Foto ufficiali disponibili in sede a Via Privata
        detta Sacra 31, Napoli.
      </p>
    </div>
  </section>
);

export default PhotoStrip;
